// Custom.
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import {
  DownloadExcelButtonProps,
  Sheet,
} from "@vocollege/components/dist/DownloadExcelButton";

export const getExcelData = (data: any, parsedData: any, variables: any) => {
  if (parsedData.length === 0) {
    return null;
  }
  const result: DownloadExcelButtonProps = {
    filename: I18n.get.languageRepresentativeEducatorDiploma.label
      .toLowerCase()
      .replaceAll(" ", "_"),
    sheets: [],
  };

  let commonHead = [
    [
      {
        richText: [
          {
            font: {
              size: 16,
              bold: true,
            },
            text: I18n.get.languageRepresentativeEducatorDiploma.label,
          },
        ],
      },
      "",
      `${I18n.get.misc.created_at} ${data.certStatisticsLanguageRepresentativeEducatorDiplomas.createdAt}\n${variables?.from} - ${variables?.to}`,
    ],
    [""],
    [],
    [
      {
        richText: [
          {
            font: {
              size: 10,
              bold: true,
            },
            text: I18n.get.vocertStatistics.quantity,
          },
        ],
      },
      "",
      parsedData.length,
    ],
  ];

  let byGroupSheet: Sheet = {
    name: I18n.get.vocertStatistics.summary,
    rows: [...commonHead],
  };

  // byGroupSheet.rows?.push([
  //   {
  //     richText: [
  //       {
  //         font: {
  //           size: 10,
  //         },
  //         text: "title",
  //       },
  //     ],
  //   },
  //   "",
  //   parsedData.length,
  // ]);

  result.sheets?.push(byGroupSheet);

  return result;
};
